export default __webpack_public_path__ + "static/media/Sinergia_LogoBannerPrincipal.5c0b3a36.png";